import React from "react"
import styled from "styled-components"

import SalesforceLink from "../salesforce/link"

const OrderedList = ({ title, list, link }) => (
  <Style>
    {title ? <h2>{title}</h2> : null}
    {list && (
      <ol>
        {list.map((item, i) => (
          <li key={i} data-n={i + 1}>
            {item}
          </li>
        ))}
      </ol>
    )}
    {link ? (
      <p>
        <SalesforceLink title={link[0].title} />
      </p>
    ) : null}
  </Style>
)
export default OrderedList

const Style = styled.div.attrs((props) => ({
  className: "promotion promotion--list",
}))`
  padding: 0 ${(props) => props.theme.gutter};
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;

  > h2 {
    font-family: Newzald Bold Italic;
    font-size: calc(1em + 2.5vmax);
    font-weight: normal;
    text-align: center;
    margin-bottom: 0.75em;
  }

  p {
    text-align: center;
    margin-top: 1.5em;
    font-size: 1.5em;
  }

  > ol,
  > ul {
    padding: 0;
    list-style: none;
    margin: 0 auto;
    font-size: calc(1em + 0.25vmax);

    > li {
      margin-bottom: 0;
      position: relative;
      padding-left: 3.25em;
      line-height: 1.45;

      + li {
        margin-top: 1.75em;
      }

      &::before {
        content: attr(data-n);
        position: absolute;
        top: -0.5em;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.75em;
        height: 2.75em;
        font-size: 80%;
        font-weight: 600;
        line-height: 2.85em;
        border-radius: 50%;
        color: ${(props) => props.theme.colors.white};
        background-color: ${(props) => props.theme.colors.pink};
      }
    }
  }
`
